import React, {Component} from 'react';
import {Link, Redirect} from 'react-router-dom';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import api from '../../../helpers/api';
import {getTranslate} from 'react-localize-redux';
import {loadLanguage} from '../../../common/redux/localeReducer';
import {notifySuccess, notifyError} from '../../../common/redux/notificationReducer';
import {loginRules} from '../rules';
import {CustomControl, CustomError, CustomForm} from '../../../common/components';
import login from '../locales/login.json';

class LoginForm extends Component {
	constructor(props) {
		super(props);

		const {loadLanguage} = props;
		loadLanguage(login);

		this.state = {
			isLoading: false,
			redirectTo: false,
			loginForm: {
				email: '',
				password: ''
			}
		}
	}

	handleSubmit = async (values) => {
		const {notifySuccess, notifyError} = this.props;
		try {
			const response = await api.post('/auth/login', values);
			notifySuccess(response.message);

			this.setState({ ...this.state, redirectTo: true});
		} catch (error) {
			notifyError(error.message);
		}
	};

	render() {
		const {translate} = this.props;
		const {loginForm, redirectTo, isLoading} = this.state;

		if (redirectTo) {
			return <Redirect to='/' />;
		}

		const loading = (
			<div className="overlay">
				<i className="fa fa-refresh fa-spin"/>
			</div>
		);

		const content = (
			<div className="login-box-body box">
				<p className="login-box-msg">{translate('login_page_title')}</p>

				<CustomForm model="loginForm"
				            initialState={loginForm}
				            validators={loginRules.validators}
				            onSubmit={this.handleSubmit}
				>
					<div className="form-group has-feedback">
						<CustomControl type="email" model="email" placeholder={translate('login_email_placeholder')}/>
						<CustomError model="email" messages={loginRules.messages} translate={translate}/>
					</div>

					<div className="form-group has-feedback">
						<CustomControl type="password" model="password" placeholder={translate('login_password_placeholder')}/>
						<CustomError model="password" messages={loginRules.messages} translate={translate}/>
					</div>

					<div className="row">
						<div className="col-xs-12 text-center">
							{
								isLoading ?	loading : (
									<button type="submit" className="btn btn-primary btn-inverse">
										{translate('login_submit_text')}
									</button>
								)
							}
						</div>
					</div>
				</CustomForm>

				<div className="social-auth-links text-center">
					<Link to="/auth/forgot-password" className="login-box-link">
						{translate('login_forgot_password_title')}
					</Link>
				</div>
			</div>
		);

		return translate('login_page_title') ? content : <div className="login-box-body box">{ loading }</div>;
	}
}

const mapStateToProps = state => ({
	translate: getTranslate(state.locale)
});

const mapDispatchToProps = dispatch => bindActionCreators({
	loadLanguage,
	notifySuccess,
	notifyError
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm);